import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule  } from 'ngx-toastr';
import { HttpClientModule } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { ModalModule } from 'ngx-bootstrap/modal';
import { UserIdleModule } from 'angular-user-idle';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { KeyboardComponent } from './custom/keyboard/keyboard.component';

import { HomeComponent } from './modules/home/home.component';
import { MenuComponent } from './modules/menu/menu.component';
import { SharedModule } from './modules/shared/shared.module';
import { ModalComponent } from './modules/shared/components/modal/modal.component';
import { ModalHerramientasComponent } from './modules/shared/components/modal-herramientas/modal-herramientas.component';

import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
export class MyHammerConfig extends HammerGestureConfig  {
  overrides = {
    // Sobreescribe configuración por defecto de HammerJS
    press: { time: 1000 }
  };
}

@NgModule({
  declarations: [
    AppComponent,
    KeyboardComponent,
    HomeComponent,
    MenuComponent,
    ModalComponent,
    ModalHerramientasComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      progressBar: true
    }),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatButtonModule,
    ModalModule.forRoot(),
    UserIdleModule.forRoot({ idle: 90, timeout: 30 }),
    SharedModule
  ],
  entryComponents: [
    KeyboardComponent, ModalComponent, ModalHerramientasComponent
  ],
  providers: [
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
